import { BankCodes } from '@revenuemarket/bank';
import { AccountStatus } from '@revenuemarket/trade';

import { API } from '~apis/axios/instance';
import { SCRAPE_STATUS } from '~apis/scrape';
import { ResponseBaseWithData } from '~types/response';

export interface LoanResponse {
  items: LoanItem[];
}
export interface LoanItem {
  name: string;
  accountNumber: string;
  startDate: string;
  endDate: string;
  interestRate: number;
  principal: number;
  balance: number;
  bankCode: BankCodes;
  status: AccountStatus;
  scrapeStatus: SCRAPE_STATUS;
}

export const getLoans = ({ companyId }: { companyId: string }) => {
  return API.get<ResponseBaseWithData<LoanResponse>>(
    `/api/v3/companies/${companyId}/cashflow-overview/loans`,
  );
};
